var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import BillingService from "../services/BillingService";
import { Can } from "../../App/utils/Authorize";
import { formatCurrencyValues } from "../../App/utils/formatter";
import Title from "../../App/components/Title";
import Notification from "../../App/components/Notification";
import Breadcrumbs from "../../App/components/Breadcrumbs";
import "../../App/styles/App.css";
import "../../App/styles/Billing.css";
import { Pagination, Select, MenuItem } from '@mui/material';
import { Tooltip } from "@mui/material";
import { ArrowDropDown, FilterAltOff } from "@mui/icons-material";
import CouponUI from "../../App/components/CouponUI";
function Billing() {
    var _a = useState([]), billings = _a[0], setBillings = _a[1];
    var _b = useState(), paginateData = _b[0], setPaginateData = _b[1];
    var _c = useState(true), hasNext = _c[0], setHasNext = _c[1];
    var _d = useState(null), dates = _d[0], setDates = _d[1];
    var _e = useState(""), referenceDates = _e[0], setReferenceDates = _e[1];
    var _f = useState(false), arrowOpen = _f[0], setArrowOpen = _f[1];
    var _g = useState(0), statusValue = _g[0], setStatusValue = _g[1];
    var _h = useState(1), currentPage = _h[0], setCurrentPage = _h[1];
    var _j = useState(0), totalItems = _j[0], setTotalItems = _j[1];
    var _k = useState(20), perPage = _k[0], setPerPage = _k[1];
    var navigate = useNavigate();
    function handleNavigate(statusId, id, sourceTable) {
        var _a, _b, _c;
        var billingItem = billings.find(function (item) {
            return item.id === id && item.source_table === sourceTable;
        });
        if (sourceTable === "billing_licenses") {
            navigate("/billing-licenses/".concat(id));
        }
        else if (sourceTable === "billings") {
            var referenceDate = (_a = billingItem === null || billingItem === void 0 ? void 0 : billingItem.formatted_month_reference_date) !== null && _a !== void 0 ? _a : null;
            var downPaymentId = (_b = billingItem === null || billingItem === void 0 ? void 0 : billingItem.down_payment_id) !== null && _b !== void 0 ? _b : null;
            var orderId = (_c = billingItem === null || billingItem === void 0 ? void 0 : billingItem.order_id) !== null && _c !== void 0 ? _c : null;
            navigate("/billings/".concat(id), {
                state: {
                    billingStatusId: statusId,
                    referenceDate: referenceDate,
                    downPaymentId: downPaymentId,
                    orderId: orderId
                }
            });
        }
    }
    useEffect(function () {
        if (dates != null) {
            var arr_dates = Object.values(dates);
            var initial_date = new Date(arr_dates[0]);
            var final_date = new Date(arr_dates[1]);
            var reference_date = "".concat(initial_date.toISOString().substring(0, 10)) +
                "TO" +
                "".concat(final_date.toISOString().substring(0, 10));
            setReferenceDates(reference_date);
            getBillings(reference_date, statusValue);
        }
        else {
            getBillings();
        }
    }, [dates]);
    useEffect(function () {
        if (statusValue !== 0) {
            getBillings(referenceDates, statusValue);
        }
    }, [statusValue]);
    function getBillings(referenceDate, status, page, rows) {
        if (referenceDate === void 0) { referenceDate = ""; }
        if (status === void 0) { status = 0; }
        if (page === void 0) { page = 1; }
        if (rows === void 0) { rows = 20; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Block.circle("[data-id=billings-grid]");
                BillingService.all(referenceDate, status, page, rows).then(function (res) {
                    var result = res.data.billings.data;
                    setBillings(result);
                    setPaginateData(result);
                    setTotalItems(res.data.billings.total);
                    if (res.data.billings.next_page_url !== null) {
                        setHasNext(true);
                    }
                    Notification().Block.remove("[data-id=billings-grid]");
                }, function (err) {
                    Notification().Block.remove("[data-id=billings-grid]");
                    if (err.response.status === 403) {
                        Notification().Notify.failure("Usuário não tem permissão para visualizar essa página!");
                    }
                    else {
                        Notification().Notify.failure(err.message);
                    }
                });
                return [2 /*return*/];
            });
        });
    }
    function handleStatusValue(event) {
        setStatusValue(Number(event.target.value));
    }
    function handleDates(values) {
        setDates(values);
    }
    function handleCalendarStyle(state) {
        var calendar = document.getElementById("calendar");
        var nodes = calendar === null || calendar === void 0 ? void 0 : calendar.querySelectorAll(".react-daterange-picker__wrapper > .react-daterange-picker__inputGroup, .react-daterange-picker__range-divider");
        setArrowOpen(state === "open");
        nodes === null || nodes === void 0 ? void 0 : nodes.forEach(function (item) {
            item.style.display = "none";
        });
    }
    function handleIconStyle() {
        var class_name = "";
        class_name += arrowOpen ? "inverted-arrow" : "";
        class_name += dates ? " colored-arrow" : "";
        return class_name;
    }
    function filterClear() {
        Notification().Block.circle("[data-id=billings-grid]");
        BillingService.all().then(function (res) {
            var result = res.data.billings.data;
            setDates(null);
            setStatusValue(0);
            setBillings(result);
            setPaginateData(res.data.billings);
            setReferenceDates("");
            if (res.data.billings.next_page_url !== null) {
                setHasNext(true);
            }
            Notification().Block.remove("[data-id=billings-grid]");
        }, function (err) {
            Notification().Block.remove("[data-id=billings-grid]");
            if (err.response.status === 403) {
                Notification().Notify.failure("Usuário não tem permissão para visualizar essa página!");
            }
            else {
                Notification().Notify.failure(err.message);
            }
        });
    }
    var handlePageChange = function (event, value) {
        if (value > Math.ceil(totalItems / perPage)) {
            return;
        }
        setCurrentPage(value);
        getBillings(referenceDates, statusValue, value, perPage);
        setDates(null);
        setStatusValue(0);
    };
    var breadcrumbsItens = [
        {
            name: "Minhas faturas",
            route: "/billings"
        }
    ];
    var formatDate = function (dateString) {
        var date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    };
    return (_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsx(Title, { text: "Minhas faturas" }), _jsx(Breadcrumbs, { itens: breadcrumbsItens }), _jsxs("table", __assign({ className: "default-table-styling", "data-id": "billings-grid" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsxs("th", __assign({ className: dates ? " d-flex justify-content-center align-items-center" : "d-flex justify-content-center align-items-center", style: dates ? { backgroundColor: "#EA5A1C", height: "65px", gap: "4px" } : { gap: "4px", height: "65px" } }, { children: ["M\u00EAs refer\u00EAncia", _jsx(DateRangePicker, { id: "calendar", autoFocus: false, calendarAriaLabel: "Calendar Picker", calendarClassName: "react-custom-calendar", calendarIcon: _jsx(ArrowDropDown, { className: handleIconStyle() }), className: "react-custom-daterange-picker", clearAriaLabel: "", clearIcon: "", closeCalendar: true, "data-testid": "date-picker", dayAriaLabel: "Dia", dayPlaceholder: "dd", disabled: false, disableCalendar: false, format: "MM/yyyy", isOpen: false, locale: "pt-BR", maxDate: new Date(), maxDetail: "year", minDate: new Date("01-01-2019"), minDetail: "year", monthAriaLabel: "M\u00EAs", monthPlaceholder: "MM", name: "datePicker", nativeInputAriaLabel: "Data", onCalendarClose: function () { handleCalendarStyle("close"); }, onCalendarOpen: function () { handleCalendarStyle("open"); }, onChange: handleDates, onFocus: function () { }, openCalendarOnFocus: false, portalContainer: null, rangeDivider: "-", required: false, showLeadingZeros: false, value: dates, yearAriaLabel: "Ano", yearPlaceholder: "AAAA" })] })), _jsx("th", { children: "Produto" }), _jsx("th", { children: "Data" }), _jsx("th", { children: "Vencimento" }), _jsx("th", { children: "Total" }), _jsxs("th", __assign({ style: statusValue !== 0 ? { backgroundColor: "#EA5A1C", display: "flex", alignItems: "center", justifyContent: "space-between" } : { display: "flex", alignItems: "center", justifyContent: "space-between" } }, { children: [_jsxs(Select, __assign({ variant: "standard", disableUnderline: true, value: statusValue.toString(), onChange: handleStatusValue, displayEmpty: true, renderValue: function (value) {
                                                var _a;
                                                var labels = { "0": "Status", "1": "Em aberto", "2": "Pago", "3": "Em atraso" };
                                                return (_a = labels[value]) !== null && _a !== void 0 ? _a : "Status";
                                            }, sx: {
                                                minWidth: 120,
                                                maxWidth: "100%",
                                                fontWeight: "bold",
                                                fontSize: 14,
                                                color: statusValue !== 0 ? "#fff" : "inherit",
                                                ".MuiSelect-select": { paddingRight: "20px !important" },
                                                ".MuiSelect-icon": { color: statusValue !== 0 ? "#fff" : "inherit", right: 0 },
                                            } }, { children: [_jsx(MenuItem, __assign({ value: "0", sx: { display: "none" } }, { children: "Status" })), _jsx(MenuItem, __assign({ value: "1" }, { children: "Em aberto" })), _jsx(MenuItem, __assign({ value: "2" }, { children: "Pago" })), _jsx(MenuItem, __assign({ value: "3" }, { children: "Em atraso" }))] })), _jsx("button", __assign({ onClick: filterClear, type: "button", className: "button-filter-clear", disabled: dates == null && statusValue == 0 }, { children: _jsx(Tooltip, __assign({ title: "Limpar filtros", placement: "top", arrow: true }, { children: _jsx(FilterAltOff, {}) })) }))] }))] }) }), _jsx("tbody", { children: _jsx(Can, __assign({ permission: "view-billing" }, { children: billings.length > 0 ? (billings.map(function (data) { return (_jsx(Tooltip, __assign({ title: "Clique para visualizar a p\u00E1gina de Detalhes da Fatura", placement: "top", arrow: true }, { children: _jsxs("tr", __assign({ onClick: function () { return handleNavigate(data.billing_status_id, data.id, data.source_table); }, style: { cursor: "pointer" } }, { children: [_jsx("td", __assign({ style: dates ? { backgroundColor: "rgba(234, 90, 28, .1)" } : {} }, { children: data.formatted_month_reference_date })), _jsx("td", { children: data.source_table === 'billing_licenses' ? 'CDN' : 'CeletiHub' }), _jsx("td", { children: data.formatted_reference_date }), _jsx("td", { children: formatDate(data.due_date) }), _jsx("td", { children: formatCurrencyValues(data.total) }), _jsx("td", __assign({ style: statusValue === 0 ? { width: "200px" } : { backgroundColor: "rgba(234, 90, 28, .1)", width: "200px" } }, { children: _jsx("div", __assign({ className: "billing-status", style: { backgroundColor: data.billing_status_icon_color, marginLeft: "1rem" } }, { children: data.billing_status_translation })) }))] })) }), data.id)); })) : (_jsx("tr", { children: _jsx("td", __assign({ className: "text-center", colSpan: 5 }, { children: "Nenhuma fatura cadastrada" })) })) })) })] })), hasNext && (paginateData !== undefined) && (_jsx("div", __assign({ className: "d-flex justify-content-end mt-4" }, { children: _jsx("div", { children: _jsx(Pagination, { count: Math.ceil(totalItems / perPage), page: currentPage, onChange: handlePageChange, color: "standard", sx: {
                            '& .MuiPaginationItem-root': {
                                color: '#ff8926',
                            },
                            '& .MuiPaginationItem-root.Mui-selected': {
                                backgroundColor: '#ff8926',
                                color: '#fff',
                            },
                            '& .MuiPaginationItem-root:hover': {
                                backgroundColor: '#ff8926',
                                color: '#fff',
                            }
                        }, showFirstButton: true, showLastButton: true }) }) }))), _jsx(CouponUI, {})] })));
}
export default Billing;
